<template>
    <router-link :to="{path: '/edit-campaign', query: {id: campaign.id}}">
        <Button class="updates-schedule-now" type="schedule-update" @click.native="fireEvents">
            Schedule Now
        </Button>
    </router-link>
</template>

<script>
import Button from '../../Button'
export default {
    name: 'ScheduleNow',
    props: {
        campaign: Object
    },
    methods: {
        fireEvents(){
            this.$ga.event('Campaign', 'Edit Campaign Open', `
                OpenedFrom: Dashboard Unscheduled Updates (Scheduled Now),
                Campaign: ${this.campaign.title}
            `)
            this.$sendMixpanelEvent('Edit Campaign Opened', {
                'Opened From': 'Dashboard Unscheduled Updates (Scheduled Now)',
                'Campaign Name': this.campaign.title
            })
        }
    },
    components: {
        Button
    }
}
</script>